// Libs
import classNames from 'classnames/bind';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './NotFound.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const NotFoundPage = (props: Props) => {
  return <>Page Not Found</>;
};

export default NotFoundPage;
